<template>
  <div class="list-stats">
    <ul class="list-stats elr-unstyled-list">
      <li><span class="elr-bold">Owner:</span> {{ herd.owner }}</li>
      <li>
        <span class="elr-bold">Number of Ponies:</span>
        {{ herd.item_count }}
      </li>
      <li v-if="herd.latest">
        <span class="elr-bold">Last Pony Added: </span>
        <router-link :to="`/herd-item/${herd.latest.id}`">{{
          herd.latest.name
        }}</router-link>
      </li>
      <li v-if="herd.priciest">
        <span class="elr-bold">Most Expensive Pony: </span>
        <router-link :to="`/herd-item/${herd.priciest.id}`">{{
          herd.priciest.name
        }}</router-link>
      </li>
      <li v-if="herd.value">
        <span class="elr-bold">Herd Value: </span>
        {{ currency(parseInt(herd.value, 10)) }}
      </li>
      <li v-if="herd.sold_value > 0">
        <span class="elr-bold">Sold Value: </span>
        {{ currency(parseInt(herd.sold_value, 10)) }}
      </li>
    </ul>
    <!-- <p>Completed Groups</p>
    <p>Near Complete Groups (75% Complete)</p> -->
  </div>
</template>

<script>
export default {
  name: 'ListStats',
  props: {
    herd: {
      type: Object,
      default: () => ({})
    },
    completed: {
      type: Array,
      default: () => ([]),
    },
    nearComplete: {
      type: Array,
      default: () => ([]),
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/config";

</style>
